import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { writeErr } from '../../common/logger';
import { repiActions } from '../../../store/repiStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { apiGet, getHostApi } from '../../../store/apiWrapper';
import { selectDefaultStyles } from '../../styling/selectDefaultStyles';
import { hasConsentInStorage, isPlusReport, isPoolReport } from '../repiUtils';
import Message from '../../common/message';
import BbInput from '../../styling/bbInput';
import BbCheckbox from '../../styling/bbCheckbox';
import SelectOption from '../../searchSections/selectOption';

import '../repi.scss';

class RepiReportCreditConfirmationPopup extends React.Component {
    mounted = false;

    static defaultProps = {
        pool: {}
    };

    state = {
        consent: this.props.consent || false,
        selectedGroup: this.props.pool.defaultGroup,
        price: this.props.price
    };

    get isPlus() { return isPlusReport(this.props.reportType); }
    get isPool() { return isPoolReport(this.props.reportType); }
    get subjectId() { return this.props.subjectId || this.props.getRepiProps().subjectId; }

    render() {
        if (!isNullOrUndefined(this.props.error))
            return <Message type="error" message={this.props.translate(this.props.error.message)} />;

        const reportName = this.props.translate(`Repi.Report.${this.props.reportName}`);
        const poolGroupsCount = Object.keys(this.props.pool.groups || {}).length;
        const requiresConsent = this.isPlus && this.props.repi.consent !== true && !hasConsentInStorage(this.subjectId) && !this.props.isPo;

        return (
            <>
                <span className="underlined-title-wrapper" style={{ marginBottom: "2em", marginTop: this.props.popup ? "0.5em" : "0" }}>
                    <h5 className="underlined-title" style={{ fontWeight: "600" }}>
                        {reportName}
                    </h5>
                </span>
                {this.isPool && this.props.pool.allowSelection && poolGroupsCount > 1 && <BbInput type="select-noformik"
                    label={this.props.translate("Repi.Search.RepiGroup")}
                    placeholder={{ type: "column" }}
                    options={this.getRepiGroupsOptions()}
                    formatOptionLabel={SelectOption}
                    onChange={(e) => this.poolGroupChanged(e.value)}
                    value={this.getSelectedGroup(this.state.selectedGroup)}
                    styles={selectDefaultStyles}
                />}
                <div className="has-text-centered" style={{ fontSize: "0.875em", padding: "2em 0.3em", visibility: this.state.price > 0 ? "visible" : "hidden" }}>
                    <Translate id="Repi.CreditPopup.Body" />
                </div>
                {requiresConsent && <div
                    className="repi-search-consent-wrapper"
                    style={{ fontSize: "0.875em", padding: "0 0.3em 2em 0.3em", display: "flex", justifyContent: "center" }}
                >
                    <BbCheckbox label={this.props.translate("Repi.Search.Consent")}
                        id="consent" value={this.state.consent}
                        onChange={(value) => this.setState({ consent: value })}
                    />
                </div>}
                <div className="modal-inner-buttons">
                    <button type="button" onClick={() => this.props.no()}
                        className={classnames("bb-button is-primary gradient-1-gray", { "is-square": localStorage.locales_button_style === "square" })}
                    >
                        <Translate id="Common.No.Upper" />
                    </button>
                    <button type="button" onClick={() => this.props.yes(requiresConsent, this.isPool ? this.state.selectedGroup : null)}
                        className={classnames("bb-button is-primary gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        disabled={requiresConsent && this.state.consent !== true}
                    >
                        <Translate id="Common.Yes.Upper" />
                    </button>
                </div>
            </>
        );
    }

    componentDidMount() {
        if (!this.mounted && this.isPool && this.state.selectedGroup === null) {
            const groups = Object.keys(this.props.pool.groups);
            this.setState({ selectedGroup: groups.length > 0 ? groups[0] : null });
        }
        this.mounted = true;
    }

    poolGroupChanged = (g) => {
        const requestParams = { ...this.props.requestParams };
        requestParams.poolGroup = parseInt(g);

        apiGet(`${getHostApi()}/api/repi/report/${this.props.reportName}/${this.subjectId}/check`, requestParams,
            s => {
                if (isNullOrUndefined(s) || !s.hasData)
                    writeErr("No data returned from API -- /check");
                else
                    this.setState({ selectedGroup: g, price: s.data });
            },
            e => writeErr(e)
        );
    }

    getRepiGroupsOptions = () => Object.keys(this.props.pool.groups || {}).map(g => ({ key: g, value: g, label: this.props.pool.groups[g] }));
    getSelectedGroup = (g) => isNullOrUndefined(g) ? {} : { key: g, value: g, label: this.props.pool.groups[g] }
}

export default withLocalize(connect(
    state => ({ repi: state.repi.search }),
    dispatch => bindActionCreators(repiActions, dispatch)
)(RepiReportCreditConfirmationPopup));